import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, message, Select } from 'antd';
import axiosInstance from '../../utils/axios';


const DistrictModal = ({ open, setOpen, states, setDistricts, selectedId, districts, selectedState}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        if (open) {
            if (selectedId !== null) {
                const item = districts.find(p => p.id === selectedId);
                setSelectedItem(item);

                if (item) {
                    form.setFieldsValue({ name: item.name, state: item.state });
                }

            } else {
                setSelectedItem(null);
                form.resetFields();
            }
        }
    }, [open, selectedId, districts]);

    const handleCancel = () => {
        setOpen(false);
        form.resetFields();
        setSelectedItem(null);
    };

    const handleFinish = async (values) => {
        setLoading(true);

        try {
            let response;
            if (selectedItem) {
                response = await axiosInstance.patch(`core/district/${selectedItem.id}/`, values);
                if (values.state === selectedState) {
                    setDistricts(prev => prev.map(p => (p.id === selectedItem.id ? response.data : p)));
                } else {
                    // remove it from the current state list if it no longer belongs
                    setDistricts(prev => prev.filter(p => p.id !== selectedItem.id));
                }
                message.success("District updated successfully!");

            } else {
                response = await axiosInstance.post(`core/district/`, values);

                if (values.state === selectedState) 
                    setDistricts(prev => [...prev, response.data]);
                
                message.success("District added successfully!");
            }

            form.resetFields();
            setOpen(false);
        } catch (error) {
            message.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={selectedItem ? "Edit District" : "Add new District"}
            open={open}
            onCancel={handleCancel}
            destroyOnClose
            okButtonProps={{
                autoFocus: true,
                htmlType: 'submit',
                loading: loading,
                disabled: loading,
            }}
            onOk={() => form.submit()}
        >
            <Form
                layout="vertical"
                form={form}
                name="language_form"
                onFinish={handleFinish}
            >
                <Form.Item
                    label="State"
                    name="state"
                    rules={[{ required: true, message: 'Please select a state' }]}
                >
                    <Select
                        disabled={selectedItem}
                        placeholder="Select a state"
                        options={states.map(state => ({ label: state.name, value: state.id }))}
                    />
                </Form.Item>
                <Form.Item
                    label="Name"
                    name="name"
                    rules={[{ required: true, message: 'Please enter a district' }]}
                >
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default DistrictModal